import { ReactNode } from "react";
import styled from "styled-components";
import ChatFooterMenu from "./subs/ChatFooterMenu";
import ChatFooterMessageInput from "./subs/ChatFooterMessageInput";

const ChatFooter = (): ReactNode => {
  return (
    <StyledChatFooter>
      <ChatFooterMenu />
      <ChatFooterMessageInput />
    </StyledChatFooter>
  );
};

const StyledChatFooter = styled.div`
  flex: none;
  min-height: 80px;
  max-height: 140px;
  display: flex;
  align-items: center;
  border-top: 1px solid #f7f6fb;
  overflow: hidden;
  pointer-events: none;
`;

export default ChatFooter;
